export default "__VITE_ASSET__BPe95fuR__"